import React, { forwardRef, ReactNode } from "react";
import { Button } from "./button";
import { twclsx } from "../../utils/cssUtil";
import { useTranslation } from "react-i18next";

interface DialogProps extends React.DialogHTMLAttributes<HTMLDialogElement> {
  children: ReactNode;
}

export const Dialog = forwardRef<HTMLDialogElement, DialogProps>(
  ({ children, className, ...rest }: DialogProps, ref) => {
    return (
      <dialog className={twclsx("modal", className)} ref={ref} {...rest}>
        <div className="modal-box">{children}</div>
      </dialog>
    );
  },
);
Dialog.displayName = "Dialog";

export const DialogActions = ({
  children,
  showOk,
  onClickOk,
  className,
}: {
  children?: ReactNode;
  showOk?: boolean;
  onClickOk?: () => void;
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className={twclsx("modal-action", className)}>
      <form method="dialog" className={"flex-1 flex"}>
        {children}
        {showOk && (
          <Button onClick={onClickOk}>{t("common_dialog_yes")}</Button>
        )}
      </form>
    </div>
  );
};

export const DialogMessage = ({
  children,
  className,
  ...rest
}: {
  children?: ReactNode;
  className?: string | undefined;
}) => {
  return (
    <p className={twclsx("pt-4 text-lg text-center", className)} {...rest}>
      {children}
    </p>
  );
};
